import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { arrayUnion, doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { app, auth, db } from '../../config/firebase';

let foregroundSubscribed = false;

const serviceWorkerUrl = () => {
  const cfg = app.options || {};
  const q = new URLSearchParams({
    apiKey: cfg.apiKey || '',
    authDomain: cfg.authDomain || '',
    projectId: cfg.projectId || '',
    storageBucket: cfg.storageBucket || '',
    messagingSenderId: cfg.messagingSenderId || '',
    appId: cfg.appId || '',
  });
  return `/firebase-messaging-sw.js?${q.toString()}`;
};

export async function registerCurrentBrowserForPush(vapidKey) {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator) || typeof Notification === 'undefined') {
    throw new Error('This browser does not support web push notifications.');
  }
  if (!(await isSupported())) throw new Error('Firebase web messaging is not supported in this browser.');
  const key = String(vapidKey || '').trim();
  if (!key) throw new Error('Enter and save the Web Push VAPID public key first.');
  const user = auth.currentUser;
  if (!user?.uid) throw new Error('Sign in before registering this browser for push notifications.');

  const permission = Notification.permission === 'granted' ? 'granted' : await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notification permission was not granted in this browser.');

  const registration = await navigator.serviceWorker.register(serviceWorkerUrl(), { scope: '/' });
  await navigator.serviceWorker.ready;
  const messaging = getMessaging(app);
  const token = await getToken(messaging, { vapidKey: key, serviceWorkerRegistration: registration });
  if (!token) throw new Error('Firebase did not return a browser push token.');

  if (!foregroundSubscribed) {
    foregroundSubscribed = true;
    onMessage(messaging, (payload) => {
      const n = payload?.notification || {};
      if (Notification.permission === 'granted' && (n.title || n.body)) {
        try { new Notification(n.title || 'TELCOFAIR', { body: n.body || '', icon: n.image || undefined, data: payload?.data || {} }); } catch (error) { console.debug('[foreground notification suppressed]', error); }
      }
    });
  }

  await setDoc(doc(db, 'users', user.uid), {
    fcmToken: token,
    fcmTokens: arrayUnion(token),
    pushPermission: 'granted',
    pushRegisteredAt: serverTimestamp(),
  }, { merge: true });
  return token;
}

export default { registerCurrentBrowserForPush };
